module.exports = __webpack_public_path__ + "img/CQ5FC.png";